'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Shorter winresDestinationFilter with search and listing.

var WinresAreaDestinations = function () {
    function WinresAreaDestinations($scope, $filter, localizationService, departureService, paramService) {
        _classCallCheck(this, WinresAreaDestinations);

        this.$scope = $scope;
        this.$filter = $filter;
        this.localizationService = localizationService;
        this.departureService = departureService;
        this.paramService = paramService;
        this.results = [];
        this.loading = false;
        this.hasMore = false;
        this.title = '';
    }

    _createClass(WinresAreaDestinations, [{
        key: '$onInit',
        value: function $onInit() {

            'winres_departures.same_area_departures';

            var _this = this;

            this.data = this.winresReservationContext.getContext();
            this.useSeoLinks = this.winresReservationContext.getSeoState();
            this.$scope.$watch('$ctrl.data.Destination', function () {
                if (!_this.data.Destination) return;
                if (_this.data.Destination.Type === 'OP') _this.title = 'winres_departures.same_area_activities';else _this.title = 'winres_departures.same_area_departures';
                if (_this.dateWatch) return;
                _this.dateWatch = _this.$scope.$watchGroup(['$ctrl.data.DefaultStartDate', '$ctrl.data.DefaultEndDate', '$ctrl.data.NumAdults', '$ctrl.data.NumChildren', '$ctrl.data.NumInfants'], function () {
                    _this.searchCriteria = {
                        IsUserInitiated: false,
                        StartDate: _this.data.DefaultStartDate,
                        EndDate: _this.data.DefaultEndDate,
                        LengthInDaysMinimum: 1,
                        LengthInDaysMaximum: 30,
                        Classifications1: _this.data.Destination.InternetClassifications[0] ? [_this.data.Destination.InternetClassifications[0].Code] : [],
                        Classifications2: [],
                        Classifications3: [],
                        Classifications4: [],
                        Classifications5: [],
                        DestinationGroup: null,
                        DestinationCodes: null,
                        ShowFullDepartures: _this.showFullDepartures === 'true' ? true : false,
                        Types: null,
                        PriceMinimum: null,
                        PriceMaximum: 5000,
                        IsOffer: null,
                        Limit: Number(_this.limit),
                        Offset: 0,
                        NumAdults: _this.data.NumAdults,
                        NumChildren: _this.data.NumChildren,
                        NumInfants: _this.data.NumInfants,
                        BusStopId: null,
                        BusRoute: null,
                        Flags: ["GetCriteriaValues", "K1ExtraAllMatchedPrices"],
                        EarliestNDeparturesPerDestination: null,
                        ChildAges: [],
                        NumRooms: 1,
                        Regions: [_this.data.Destination.SubGroup],
                        IgnoreCapacity: _this.ignoreCapacity === 'true' ? true : false,
                        IgnoreMissingPrices: _this.ignoreMissingPrices === 'true' ? true : false,
                        PriceCategories: [],
                        Sort: []

                        // Clear results.
                    };_this.results = [];
                    _this.load(_this.searchCriteria).then(function (results) {
                        _this.results = results;
                    });
                });
            });

            this.$scope.getRoundedPrice = function (price) {
                var decimalPlaces = _.isInteger(price) ? 0 : 2;
                return _this.$filter('currency')(price, '€', decimalPlaces);
            };

            // Get Winres params
            // Hide results while loading
            this.getWinresParams();
        }
    }, {
        key: 'modifyResult',
        value: function modifyResult(result) {
            var description;
            switch (this.descriptionSource) {
                case 'headline':
                    description = result.Destination.Headline;
                    break;
                case 'description':
                default:
                    description = result.Destination.DescriptionOfDestination;
            }

            description = description.replace(/\[kuvat\]/i, '');

            var numChars = 400;
            if (this.descriptionLength) {
                numChars = parseInt(this.descriptionLength) || 400;
            }

            if (numChars && description.length > numChars) {
                description = description.substr(0, numChars + 1).replace(/( | *[^ ]+)$/, '') + '...';
            }

            result.Description = description;

            // Prevent reservation link change
            if (this.withReserveLink !== 'false') {
                return;
            }

            result.ReservationLink = (0, _utils.getReservationLinkWithWPMLAndSeo)(this.reservationLinkTemplate, result.Destination.DestinationName, result.Destination.DestinationCode, result.StartDate.split('T')[0], result.EndDate.split('T')[0], this.localizationService.getLanguage(), 2, 0, 0, false, // No dates
            this.winresReservationContext.getSeoState(), // seo
            false, // wpml
            false); // departure

            //result.ReservationLink = getReservationLink(this, result);
        }
    }, {
        key: 'load',
        value: function load(searchCriteria) {
            var _this2 = this;

            this.loading++;

            var reserveLink = this.withReserveLink !== 'false';
            var language = this.localizationService.getLanguage();

            var search = this.departureService.searchReservableItemsWithSearchDayCapacity(searchCriteria, reserveLink, language);

            this.loadingPromise = search;

            return search.then(function (response) {
                var results = response.Results;
                _this2.hasMore = response.HasMore;
                _.each(results, function (result) {
                    return _this2.modifyResult(result);
                });
                _this2.loading--;
                return results;
            });
        }
    }, {
        key: 'loadMore',
        value: function loadMore() {
            var _this3 = this;

            if (this.loading) return;
            this.searchCriteria.Offset = this.results.length;
            this.load(this.searchCriteria).then(function (results) {
                _this3.results = _this3.results.concat(results);
            });
        }
    }, {
        key: 'getWinresParams',
        value: function getWinresParams() {
            var _this4 = this;

            this.canShowResults = false;

            this.paramService.getWinresParam('CanShowProductName').then(function (param) {
                _this4.showProductName = param.toUpperCase() === 'TRUE';
                _this4.canShowResults = true;
            });
        }
    }]);

    return WinresAreaDestinations;
}();

WinresAreaDestinations.$inject = ['$scope', '$filter', 'localizationService', 'departureService', 'paramService'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'area-destinations';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('area-destinations', require('./winresAreaDestinations.html'));
}]);

_module3.default.component('winresAreaDestinations', {
    templateUrl: getTemplate,
    controller: WinresAreaDestinations,
    bindings: {
        // Departure limit for search criteria
        limit: '@',

        // Ignore capacity for search criteria
        ignoreCapacity: '@',

        // Ignore missing prices for search criteria
        ignoreMissingPrices: '@',

        // Show only reservable (frontend check)
        showOnlyReservable: '@',

        // true (default)/ false. If false, the reservelink is created in the front end.
        withReserveLink: '@',

        // Overrides the url returned by the BE, url of the kohdesivu/matkasivu, before /#!/.
        // if this does not have 'http' in the string (https also has the 'http' part in it) it will take current url and add the value of this to the end of it
        // also accepts ../ to go one "folder" up
        reservationLinkTemplate: '@',

        // Either 'description' (default) or 'headline'
        descriptionSource: '@',

        // Hide result star rating. true/false
        hideRating: '@'
    },
    require: {
        winresReservationContext: '^^winresReservationContext'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresAreaDestinations/winresAreaDestinations.js
// module id = 495
// module chunks = 2